import confettiLogo from './ConfettiLogo'
import confettiTriangle from './ConfettiTriangle'
import confettiCircle from './ConfettiCircle'
import confettiCross from './ConfettiCross'
import confettiRamen from './ConfettiRamen'
import confettiRectangle from './ConfettiRectangle'
import confettiStar from './ConfettiStar'

export default {
  confettiLogo,
  confettiTriangle,
  confettiCircle,
  confettiCross,
  confettiRamen,
  confettiRectangle,
  confettiStar
}
